(() => {
  const $ = (root, s) => root.querySelector(s);
  const $$ = (root, s) => Array.from(root.querySelectorAll(s));

  function renderStars(n) {
  const full = Math.max(0, Math.min(5, Number(n) || 0));
  let html = `<div class="tp2__starRow" aria-label="${full} out of 5 stars">`;
  for (let i = 1; i <= 5; i++) {
    const on = i <= full;
    html += `
      <span class="tp2__starBox ${on ? "is-on" : "is-off"}" aria-hidden="true">
        <svg class="tp2__starSvg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
        </svg>
      </span>
    `;
  }
  html += `</div>`;
  return html;
}



  async function loadJson(url) {
    const res = await fetch(url, { cache: "no-store" });
    if (!res.ok) throw new Error("fetch failed");
    return await res.json();
  }

  function initials(name) {
    const n = String(name || "").trim();
    if (!n) return "U";
    const parts = n.split(/\s+/);
    return (parts[0][0] + (parts[1]?.[0] || "")).toUpperCase();
  }

  function timeAgo(dateStr) {
    // 轻量模拟 trustpilot 的“X hours ago”
    const t = Date.parse(dateStr);
    if (!Number.isFinite(t)) return "";
    const diff = Date.now() - t;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    if (hours < 24) return `${Math.max(1, hours)} hours ago`;
    const days = Math.floor(hours / 24);
    return `${days} days ago`;
  }

  function computeDist(reviews) {
    const counts = {1:0,2:0,3:0,4:0,5:0};
    reviews.forEach(r => counts[r.rating] = (counts[r.rating]||0) + 1);
    const total = reviews.length || 1;
    const pct = {};
    for (let i=1;i<=5;i++) pct[i] = Math.round((counts[i]/total)*100);
    return { counts, pct, total };
  }

  function renderDist(root, dist, activeSet) {
    const wrap = $(root, "[data-tp2-dist]");
    wrap.innerHTML = "";
    for (let s=5; s>=1; s--) {
      const row = document.createElement("div");
      row.className = "tp2__distRow";
      row.innerHTML = `
        <input class="tp2__check" type="checkbox" data-star="${s}" ${activeSet.has(String(s)) ? "checked" : ""}/>
        <div class="tp2__distLabel">${s}-star</div>
        <div class="tp2__bar"><div class="tp2__barFill" style="width:${dist.pct[s]}%"></div></div>
        <div class="tp2__pct">${dist.pct[s]}%</div>
      `;
      wrap.appendChild(row);
    }
  }

  function renderMediaThumbs(r) {
  if (!Array.isArray(r.media) || !r.media.length) return "";

  const items = r.media
    .filter(m => m && m.src)
    .map((m, i) => {
      const type = (m.type || "").toLowerCase();
      const src = m.src;
      const alt = m.alt || "Customer media";
      const isVideo = type === "video" || /\.(mp4|webm|ogg)$/i.test(src);

      return `
        <button class="tp2__thumb" type="button"
          data-media-open
          data-media-index="${i}"
          data-src="${src}"
          data-type="${isVideo ? "video" : "image"}"
          aria-label="Open media">
          ${isVideo
            ? `<div class="tp2__thumbVideo">
                 <video src="${src}" muted playsinline preload="metadata"></video>
                 <span class="tp2__play">▶</span>
               </div>`
            : `<img src="${src}" loading="lazy" alt="${escapeHtml(alt)}">`
          }
        </button>
      `;
    }).join("");

  return `<div class="tp2__thumbs">${items}</div>`;
}

function renderReview(r) {
  const thumbs = renderMediaThumbs(r);
  const mediaItems = Array.isArray(r.media) ? r.media.filter(m => m && m.src) : [];
  const mediaAttr = escapeHtml(JSON.stringify(mediaItems));

  return `
    <article class="tp2__review" data-media-items='${mediaAttr}'>
      <div class="tp2__head">
        <div class="tp2__user">
          <div class="tp2__avatar">${initials(r.name)}</div>
          <div class="tp2__who">
            <div class="tp2__name">${escapeHtml(r.name)}</div>
            <div class="tp2__meta">${escapeHtml(r.country)} · ${r.verified ? "Verified" : "Unverified"}</div>
          </div>
        </div>
        <div class="tp2__time">${timeAgo(r.date)}</div>
      </div>

      <div class="tp2__stars">${renderStars(r.rating)}</div>


      ${thumbs}

      ${r.title ? `<div class="tp2__title">${escapeHtml(r.title)}</div>` : ""}
      <div class="tp2__text">${escapeHtml(r.text || "")}</div>

      <div class="tp2__tagRow">
        <span class="tp2__tag">${escapeHtml(r.date)}</span>
        ${r.verified ? `<span class="tp2__tag">Verified</span>` : ``}
      </div>
    </article>
  `;
}


  function escapeHtml(str) {
    return String(str || "")
      .replaceAll("&","&amp;")
      .replaceAll("<","&lt;")
      .replaceAll(">","&gt;")
      .replaceAll('"',"&quot;")
      .replaceAll("'","&#039;");
  }

  function init(root) {
    const jsonUrl = root.getAttribute("data-json");
    const initial = Math.max(1, Number(root.getAttribute("data-initial")) || 10);
    const step = Math.max(1, Number(root.getAttribute("data-step")) || 5);

    const loading = $(root, "[data-tp2-loading]");
    const err = $(root, "[data-tp2-error]");
    const list = $(root, "[data-tp2-list]");
    const moreBtn = $(root, "[data-tp2-more]");
    const qInput = $(root, "[data-tp2-q]");
    const sortSel = $(root, "[data-tp2-sort]");

    const avgEl = $(root, "[data-tp2-avg]");
    const starsEl = $(root, "[data-tp2-stars]");
    const totalEl = $(root, "[data-tp2-total]");
    const totalBase = Number(root.getAttribute("data-total-base")) || 0;
    const brandEl = $(root, "[data-tp2-brand]");

    const chips = $(root, "[data-tp2-chips]");

    let all = [];
    let filtered = [];
    let shown = initial;

    // left star filter (multi)
    const activeStars = new Set(); // if empty => all
    let chipQuery = ""; // optional

    const applySort = () => {
      const mode = sortSel.value;
      const arr = [...filtered];
      if (mode === "high") arr.sort((a,b) => b.rating - a.rating || (Date.parse(b.date)||0)-(Date.parse(a.date)||0));
      else if (mode === "low") arr.sort((a,b) => a.rating - b.rating || (Date.parse(b.date)||0)-(Date.parse(a.date)||0));
      else arr.sort((a,b) => (Date.parse(b.date)||0)-(Date.parse(a.date)||0));
      filtered = arr;
    };

    const applyFilter = () => {
      const q = (qInput.value || "").trim().toLowerCase();
      const needStars = activeStars.size ? activeStars : null;

      filtered = all.filter(r => {
        if (needStars && !needStars.has(String(r.rating))) return false;

        const hay = `${r.title} ${r.text} ${r.name} ${r.country}`.toLowerCase();
        if (chipQuery && !hay.includes(chipQuery)) return false;
        if (q && !hay.includes(q)) return false;
        return true;
      });

      applySort();
      shown = Math.min(shown, Math.max(initial, filtered.length)); // keep sensible
      render();
      updateSummary();
    };

    const render = () => {
      const slice = filtered.slice(0, shown);
      list.innerHTML = slice.map(renderReview).join("");

      if (filtered.length <= shown) {
        moreBtn.disabled = true;
        moreBtn.textContent = "No more reviews";
      } else {
        moreBtn.disabled = false;
        moreBtn.textContent = "Show more reviews";
      }
    };

    // ===== Lightbox (modal zoom) =====
let lbState = { open:false, items:[], index:0 };

function ensureLightbox() {
  if (root.querySelector("[data-tp2-lightbox]")) return;

  const lb = document.createElement("div");
  lb.className = "tp2__lightbox";
  lb.setAttribute("data-tp2-lightbox", "");
  lb.hidden = true;

  lb.innerHTML = `
  <div class="tp2__lbBackdrop" data-lb-close></div>
  <div class="tp2__lbPanel" role="dialog" aria-modal="true" aria-label="Media viewer">
    <div class="tp2__lbTop">
      <div class="tp2__lbCaption" data-lb-caption>Customer media</div>
      <button class="tp2__lbClose" type="button" data-lb-close aria-label="Close">×</button>
    </div>

    <button class="tp2__lbNav tp2__lbPrev" type="button" data-lb-prev aria-label="Previous">‹</button>
    <button class="tp2__lbNav tp2__lbNext" type="button" data-lb-next aria-label="Next">›</button>

    <div class="tp2__lbBody">
      <div class="tp2__lbInner" data-lb-inner></div>
    </div>
  </div>
`;

  root.appendChild(lb);
}

function openLightbox(items, startIndex) {
  ensureLightbox();

  lbState.open = true;
  lbState.items = items || [];
  lbState.index = Math.max(0, Math.min(startIndex || 0, lbState.items.length - 1));

  const lb = root.querySelector("[data-tp2-lightbox]");
  lb.hidden = false;
  document.documentElement.style.overflow = "hidden";
  renderLightbox();
}

function closeLightbox() {
  const lb = root.querySelector("[data-tp2-lightbox]");
  if (!lb) return;
  lb.hidden = true;
  document.documentElement.style.overflow = "";
  lbState = { open:false, items:[], index:0 };
}

function renderLightbox() {
  const inner = root.querySelector("[data-lb-inner]");
  const caption = root.querySelector("[data-lb-caption]");
  const prevBtn = root.querySelector("[data-lb-prev]");
  const nextBtn = root.querySelector("[data-lb-next]");

  const m = lbState.items[lbState.index];
  if (!m) return;

  inner.innerHTML = "";
  const type = (m.type || "").toLowerCase();
  const src = m.src;
  const alt = m.alt || "Customer media";
  const isVideo = type === "video" || /\.(mp4|webm|ogg)$/i.test(src);

  if (isVideo) {
    const v = document.createElement("video");
    v.src = src;
    v.controls = true;
    v.autoplay = true;
    v.playsInline = true;
    inner.appendChild(v);
  } else {
    const img = document.createElement("img");
    img.src = src;
    img.alt = alt;
    inner.appendChild(img);
  }

  caption.textContent = alt;

  // nav visibility
  const canNav = lbState.items.length > 1;
  prevBtn.style.display = canNav ? "" : "none";
  nextBtn.style.display = canNav ? "" : "none";
}

function navLightbox(dir) {
  if (!lbState.open) return;
  const n = lbState.items.length;
  if (n <= 1) return;
  lbState.index = (lbState.index + dir + n) % n;
  renderLightbox();
}

// click handlers (event delegation)
root.addEventListener("click", (e) => {
  const openBtn = e.target.closest("[data-media-open]");
  if (openBtn) {
    // collect all media in this review
    const review = openBtn.closest(".tp2__review");
    const itemsJson = review?.getAttribute("data-media-items");
    const items = itemsJson ? JSON.parse(itemsJson) : [];
    const idx = Number(openBtn.getAttribute("data-media-index") || 0);
    openLightbox(items, idx);
    return;
  }

  if (e.target.closest("[data-lb-close]")) {
    closeLightbox();
    return;
  }
  if (e.target.closest("[data-lb-prev]")) {
    navLightbox(-1);
    return;
  }
  if (e.target.closest("[data-lb-next]")) {
    navLightbox(1);
    return;
  }
});

// keyboard support
document.addEventListener("keydown", (e) => {
  if (!lbState.open) return;
  if (e.key === "Escape") closeLightbox();
  if (e.key === "ArrowLeft") navLightbox(-1);
  if (e.key === "ArrowRight") navLightbox(1);
});


    const updateSummary = () => {
      // Summary based on ALL reviews (像 Trustpilot 左侧那样)
      const dist = computeDist(all);
      totalEl.textContent = (dist.total + totalBase).toLocaleString();

      const avg = all.reduce((a,r)=>a+r.rating,0) / (all.length || 1);
      avgEl.textContent = avg.toFixed(1);
      starsEl.innerHTML = renderStars(Math.round(avg));


      // distribution UI
      renderDist(root, dist, activeStars);
      // bind checkbox events
      $$($(root,"[data-tp2-dist]"), "input[type=checkbox]").forEach(cb => {
        cb.onchange = () => {
          const s = cb.getAttribute("data-star");
          if (cb.checked) activeStars.add(String(s));
          else activeStars.delete(String(s));
          shown = initial;
          applyFilter();
        };
      });
    };

    const bindChips = () => {
      if (!chips) return;
      chips.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-chip]");
        if (!btn) return;
        const v = btn.getAttribute("data-chip");
        const isActive = btn.classList.contains("is-active");

        // single-select behavior (像 trustpilot 的 tags)
        $$(chips, ".tp2__chip").forEach(x => x.classList.remove("is-active"));

        if (isActive) {
          chipQuery = "";
        } else {
          btn.classList.add("is-active");
          chipQuery = String(v || "").toLowerCase();
        }

        shown = initial;
        applyFilter();
      });
    };

    (async () => {
      try {
        const data = await loadJson(jsonUrl);
        brandEl.textContent = data.brand || "𝐇𝐞𝐚𝐥𝐫𝐢𝐳𝐞";

        all = (data.reviews || []).map((r, idx) => ({
            id: r.id || `r_${idx+1}`,
            name: r.name || "Anonymous",
            rating: Math.max(1, Math.min(5, Number(r.rating) || 5)),
            title: r.title || "",
            text: r.text || "",
            date: r.date || "",
            verified: !!r.verified,
            country: r.country || "US",
            media: Array.isArray(r.media) ? r.media : []
        }));

        // default sort recent
        all.sort((a,b)=> (Date.parse(b.date)||0)-(Date.parse(a.date)||0));

        filtered = [...all];
        applySort();

        loading.hidden = true;
        err.hidden = true;

        // events
        let t = null;
        qInput.addEventListener("input", () => {
          clearTimeout(t);
          t = setTimeout(() => { shown = initial; applyFilter(); }, 160);
        });

        sortSel.addEventListener("change", () => { applySort(); render(); });

        moreBtn.addEventListener("click", () => {
          shown = Math.min(filtered.length, shown + step);
          render();
        });

        bindChips();
        updateSummary();
        render();

      } catch (e) {
        console.error(e);
        loading.hidden = true;
        err.hidden = false;
      }
    })();
  }

  function boot() {
    document.querySelectorAll("[data-tp2]").forEach(init);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
